import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const Menu = theme(Headless.Menu, [
  css({
    display: css.value('block'),
    boxSizing: css.value('border-box'),
    margin: 0,
    padding: 0,
    paddingY: 50,
    listStyleType: css.value('none'),
    overflowY: css.value('auto'),
    userSelect: css.value('none'),
    height: 'fill',
    outline: css.value('none'),
  }),
]);

export const MenuItemSeparator = theme(Headless.MenuItemSeparator, [
  css({
    height: css.value('1px'),
    marginY: 50,
    marginX: 0,
    background: css.value('$borderColor.neutral'),
  }),
]);

export const MenuItem = theme(Headless.MenuItem, [
  css({
    cursor: css.value('pointer'),
    boxSizing: css.value('border-box'),
    marginY: 0,
    marginX: 50,
    paddingY: 50,
    paddingX: 75,
    color: 'brand',
    backgroundColor: css.value('initial'),
    borderRadius: 'small',
    outline: css.value('none'),
    lineHeight: css.value('20px'),
    minWidth: css.value('160px'),
    font: 'bodyEmphasized',

    '&:hover': {
      backgroundColor: 'container',
      color: 'primary',
    },

    [Headless.MenuItemVariants.type.destructive]: {
      color: 'critical',
    },

    [Headless.MenuItemVariants.disabled.true]: {
      cursor: css.value('default'),
      backgroundColor: css.value('initial'),
      color: 'disabled',
    },

    [Headless.MenuItemVariants.modality.keyboard]: {
      // TODO: unhard-code this when we can apply alpha to token colors
      focusRing: css.value('0 0 0 4px rgb(58 151 212 / 28%)'),
      keyline: css.value('rgb(7 89 150 / 36%)'),
    },
  }),
]);

export const MenuGroup = theme(Headless.MenuGroup, [css({margin: 0})]);

export const MenuGroupHeading = theme(Headless.MenuGroupHeading, [
  css({
    font: 'kicker',
    color: 'secondary',
    display: css.value('block'),
    lineHeight: css.value('20px'),
    marginX: 50,
    paddingY: 50,
    paddingX: 75,
  }),
]);

export const MenuGroupItems = theme(Headless.MenuGroupItems, [
  css({
    listStyle: css.value('none'),
    margin: 0,
    padding: 0,
    layout: 'column',
  }),
]);
